<div mat-dialog-title class="ds">
  <span>{{ appStrings.touchpoints_mergeTouchpointWithAccount }}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="content ds">
  <div class="dialog-body">
    @if (loading) {
      <div class="modal-loading-overlay">
        <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
      </div>
    }

    <!-- Touchpoint info -->
    <div class="info-row">
      <typography class="label" variant="mat-caption-1" weight="regular">
        {{ appStrings.label_type }}
      </typography>
      <typography class="details" variant="mat-body-1" weight="medium">
        {{ touchpointTypeLabel }}
      </typography>
    </div>
    <div class="info-row">
      <typography class="label" variant="mat-caption-1" weight="regular">
        {{ appStrings.label_subject }}
      </typography>
      <typography class="details" variant="mat-body-1" weight="medium">
        {{ touchpoint.subject }}
      </typography>
    </div>

    <ds-divider></ds-divider>

    <!-- Account Name search -->
    <div class="field-row">
      <ds-autocomplete
        [label]="appStrings.leads_mergeAccountName"
        label_orientation="vertical-label"
        [options]="accountOptions"
        [control]="form.controls.accountName"
        fullFilter="true"
        drop_icon="search"
        class="fill-width no-subscript">
      </ds-autocomplete>
    </div>

    <!-- Selected account details -->
    @if (selectedAccount) {
      <div class="account-details">
        <div class="detail-row">
          @if (!selectedAccount.isLead) {
            <div class="detail-column">
              <typography class="label" variant="mat-caption-1" weight="regular">
                {{ appStrings.label_bpNumber }}
              </typography>
              <typography class="details" variant="mat-body-1" weight="medium">
                {{ selectedAccount.bpNumber }}
              </typography>
            </div>
          }
          <div class="detail-column">
            <typography class="label" variant="mat-caption-1" weight="regular">
              {{ appStrings.accounts_lnStatus }}
            </typography>
            <typography class="details" variant="mat-body-1" weight="medium">
              {{ lnStatuses[selectedAccount.status] }}
            </typography>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-column">
            <typography class="label" variant="mat-caption-1" weight="regular">
              {{ appStrings.accounts_labelAddress }}
            </typography>
            <typography class="details" variant="mat-body-1" weight="medium">
              {{ selectedAccount.address }}
            </typography>
          </div>
        </div>
      </div>
    }

    <ds-alert alert_type="info" [alert_message]="appStrings.leads_mergeCannotBeUndone"></ds-alert>
  </div>
</div>

<div mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    <ds-button type="secondary" size="medium" variant="label-only"
      [label]="appStrings.button_cancel"
      mat-dialog-close>
    </ds-button>
    <ds-button type="primary" size="medium" variant="label-only"
      [label]="appStrings.touchpoints_mergeTouchpoint"
      [isDisabled]="!selectedAccount"
      (onClick)="merge()">
    </ds-button>
  </div>
</div>

<ds-dialog
  [title]="appStrings.touchpoints_mergeTouchpointWithAccount"
  [description]="confirmDialogContent"
  [actionButtons]="confirmDialogButtons"
  [open]="confirmDialogOpen$">
</ds-dialog>
